import React, { FunctionComponent, useState, useEffect, useCallback } from "react";

import { ToggleSwitch } from "@itwin/itwinui-react";
import { AbstractWidgetProps, StagePanelLocation, StagePanelSection, UiItemsProvider} from "@itwin/appui-abstract";
import { PrimitiveValue, PropertyDescription, PropertyRecord, PropertyValueFormat, StandardTypeNames } from "@itwin/appui-abstract";
import { PropertyGrid, PropertyGridContextMenuArgs, SimplePropertyDataProvider } from "@itwin/components-react";
import { Orientation } from "@itwin/core-react";

import { cSelection } from "./Selection";
import { cPropertiesApi } from "./PropertiesApi";

import "./PropertyGrid.scss";

class gridDataProvider extends SimplePropertyDataProvider {

  constructor (elementId: string) {
    super();

    if (!cPropertiesApi.getPropertyViewTabs()) return;
    if (!cPropertiesApi.getPropertyData()) return;
    
    let i = 0;
    for (const section of cPropertiesApi.getSectionList()) {
      this.addCategory({
        name: section,
        label: section,
        expand: true,
      });

      const sectionProps = cPropertiesApi.getSectionProperties(section);
      if (sectionProps) {
        sectionProps.forEach((pValue:string, pName:string) => {
          if (pName == "Tag") return;
          let pLabel = cPropertiesApi.getPropertyDisplay(section, pName);
          if (pLabel == "") pLabel = pName;
          const propRec = this.gridRecord(pLabel, pValue);
          this.addProperty(propRec, i);
        });
      }
      i++;
    }
  }

  public gridRecord(name: string, value: any, typename: string = StandardTypeNames.String) : PropertyRecord {
    const v = {
      valueFormat: PropertyValueFormat.Primitive,
      value,
      displayValue: value.toString(),
    } as PrimitiveValue;
    
    const p = {
      name: name,
      displayLabel: name,
      typename,
    } as PropertyDescription;

    return new PropertyRecord(v, p);
  }

}

export const PropertyGridWidget: React.FunctionComponent<{elementId: string}> = ({elementId}) => {
//export const PropertyGridWidget: React.FunctionComponent = () => {
//    const [_elementTag, setElementId] = React.useState(elementId);
//    const [_elementTag, setElementId] = React.useState("");

  // useEffect(() => {
  // }, []);

  const _getDataProvider = useCallback((e): SimplePropertyDataProvider => {

    const dataProvider: SimplePropertyDataProvider = new gridDataProvider(e);

    return dataProvider;
//  }, [_elementTag]);
  }, []);

  const _handleLinkClick = async (args: PropertyRecord, text: string) => {
    console.log("Link Click");
  }

  const _handleContextMenu = async (args: PropertyGridContextMenuArgs) => {
    console.log("Right Click");
  }

  const _handleSelectionChange = async (args: PropertyRecord) => {
  }

  return (
    <>
      <div>
      <PropertyGrid dataProvider={_getDataProvider("")} 
                    orientation={Orientation.Horizontal} isOrientationFixed={true}
//                    onPropertyContextMenu={_handleContextMenu}
                    onPropertySelectionChanged={_handleSelectionChange}
                    isPropertyEditingEnabled={true}
                    isPropertySelectionOnRightClickEnabled={true}
      />
      </div>
    </>
  );
};

const PropertyWidget: FunctionComponent = () => {
  const [_elementTag, setElementTag] = useState("");
  const [_showProperty, setShowProperty] = useState(false);
  const [_tag, setTag] = useState("");

  const updateGrid = async (elementTags : string[]) => {

    const tag = elementTags[0];
    if (tag) {
      await cPropertiesApi.loadPropertyTabData(tag);
      setTag(tag);
    } else {
      cPropertiesApi.emptyPropertyData();
      setTag("");
    }
    
    setElementTag(tag);
  }

  const onToggleShowProperty = async (toggle : boolean) => {

    if (toggle) {
      cSelection.setOnElementSelected("propertyTab", updateGrid);
      const elementIds = await cSelection.getSelectedTags();
      await updateGrid(elementIds);
      setShowProperty(true);
    } else {
      cSelection.setOnElementSelected("propertyTab");
      setShowProperty(false);
    }
  }

  return (
    <div>
    <div className="search-options">
    <span style={{fontSize: "medium"}}><span className="icon icon-properties"> </span>Properties</span>
    <ToggleSwitch onChange={(e) => onToggleShowProperty(e.target.checked)}></ToggleSwitch>
    </div>
    {_showProperty && <div className="tag-options">
    <span>Tag No: </span><span>{_tag}</span>
    </div>
    }
    <div>
    {_showProperty && <PropertyGridWidget elementId={_elementTag} />}
    </div>
    </div>
  )
}

export class cPropertyWidget implements UiItemsProvider {
  public readonly id = "PropertyWidget";

  public provideWidgets(stageId: string, stageUsage: string, location: StagePanelLocation, section?: StagePanelSection) : ReadonlyArray<AbstractWidgetProps> {
    const widgets: AbstractWidgetProps[] = [];

    if (location === StagePanelLocation.Right && section === StagePanelSection.Start) {
      const propertyWidget: AbstractWidgetProps = {
        id: "PropertyWidget",
        label: "Properties",
        getWidgetContent() {
          return (
            <div>
            <PropertyWidget/>
            </div>
          )
        }
      }

      widgets.push(propertyWidget);
    }

    return widgets;
  }
}